import { Component } from '@angular/core';

@Component({
  selector: 'cm-doubt-action',
  templateUrl: './doubt-action.component.html',
  styleUrls: ['./doubt-action.component.scss']
})
export class DoubtActionComponent{}
